export default {
    routings: [],
    routing: {},
    activeRouteId: 0, 
    totalItems: null,
    totalPage: null,
}